var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 157,
    viewBox: "0 0 157 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_299_9634)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 75,
    transform: "matrix(-1 0 0 1 153.621 3.5)",
    fill: "#05275D",
    fillOpacity: 0.77
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: -1.5,
    width: 153,
    height: 153,
    rx: 76.5,
    transform: "matrix(-1 0 0 1 156.621 3.5)",
    stroke: "white",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.371 107V97.5H59.6211V107H121.371ZM42.5211 102.25L66.2711 78.5L42.5211 54.75L35.8711 61.4L52.9711 78.5L35.8711 95.6L42.5211 102.25ZM121.371 83.25V73.75H73.8711V83.25H121.371ZM121.371 59.5V50H59.6211V59.5H121.371Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_299_9634",
    x: -10.3789,
    y: -10.5,
    width: 178,
    height: 178,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_299_9634"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_299_9634",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuActiveIcon);
export default __webpack_public_path__ + "static/media/menu-active-icon.ed58e847403e39f2fe4acac693e3c29c.svg";
export { ForwardRef as ReactComponent };